import type { WhitelistItem } from "@gearbox-protocol/cli-utils";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { useAsyncFn } from "react-use";

interface WhitelistDeleteDialogProps {
  category: string;
  item: WhitelistItem;
  onClose: () => void;
}

const WhitelistDeleteDialog: FC<WhitelistDeleteDialogProps> = props => {
  const { category, item, onClose } = props;

  const [{ loading, error }, submit] = useAsyncFn(async () => {
    await api.deleteWhitelist(category, [item]);
    onClose();
    window.location.reload();
  }, [category, item, onClose]);

  return (
    <Dialog modal open={true} onOpenChange={() => onClose()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete whitelist item</DialogTitle>
          <DialogDescription>
            Please confirm deletion of <pre>{item.address}</pre> from whitelist
          </DialogDescription>
        </DialogHeader>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            variant="destructive"
            disabled={loading}
            loading={loading}
            onClick={submit}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WhitelistDeleteDialog;
